{
    "UploadfilesFilename": "Nome del file",
    "UploadfilesFilesize": "Dimensione del file",
    "UploadfilesEmailserroredsendingseebelow": "Clicca per maggiori informazioni",
    "UploadfilesSuccesswitherrorparagraph": "Gli utenti sono stati configurati. Tuttavia, si è verificato un errore nell'invio delle e-mail di benvenuto.",
    "Resulttableheaderusername": "Nome utente",
    "Resulttableheaderemail": "Indirizzo e-mail",
    "Resulttableheaderrptaccess": "Accesso ai rapporti",
    "Resulttableheaderisadmin": "L'amministrazione?",
    "Resulttableheaderisocagent": "L'OC è un agente?",
    "Resulttableheaderenhancemobileapp": "App mobile potenziata?",
    "LanguageBulkInsertUsers_UploadfilesHeader1": "Caricamento massivo degli utenti",
    "LanguageBulkInsertUsers_UploadfilesSubheader1": "Importazione del file.",
    "LanguageBulkInsertUsers_UploadfilesButton1": "Inizio",
    "LanguageBulkInsertUsers_UploadfilesSubheader2": "Elaborazione.",
    "LanguageBulkInsertUsers_UploadfilesButton2": "Indietro",
    "LanguageBulkInsertUsers_UploadfilesButton3": "Confermare",
    "LanguageBulkInsertUsers_UploadfilesSubheader3": "Importazione.",
    "LanguageBulkInsertUsers_UploadfilesSubheader4": "Ops.",
    "LanguageBulkInsertUsers_UploadfilesSubheader5": "Conferma.",
    "LanguageBulkInsertUsers_UploadfilesSubheader6": "Successo.",
    "LanguageBulkInsertUsers_UploadfilesButton4": "Fatto",
    "LanguageBulkInsertUsers_UploadfilesSuccessparagraph1": "Evviva! Abbiamo configurato con successo i vostri utenti.",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart1": "Iniziate scaricando e compilando il modulo",
    "LanguageBulkInsertUsers_UploadfilesStarttextbutton": "Modello CSV",
    "LanguageBulkInsertUsers_UploadfilesStarttextpart2": "fornito.",
    "LanguageBulkInsertUsers_UploadfilesConfirmationtext": "Confermare che tutto è stato digitato correttamente e procedere all'importazione del file completato (eventuali errori nel file saranno rilevati durante la configurazione):",
    "LanguageBulkInsertUsers_UploadfilesChoosefile": "Scegliere il file",
    "LanguageBulkInsertUsers_UploadfilesDraganddrop": " o trascinare e rilasciare qui.",
    "LanguageBulkInsertUsers_UploadfilesDrophere": "Lasciate qui i vostri file...",
    "LanguageBulkInsertUsers_UploadfilesFiledetails": "Dettagli del file:",
    "LanguageBulkInsertUsers_PromptdefaultcloseMessage": "Siete sicuri di voler chiudere la finestra e perdere i progressi?",
    "LanguageBulkInsertUsers_PromptdefaultcloseConfirm": "Sì",
    "LanguageBulkInsertUsers_PromptdefaultcloseCancel": "Annullamento",
    "LanguageBulkInsertUsers_ValidationError": "Errore: Non è stato possibile elaborare la richiesta di bulk provisioning. Per ulteriori informazioni, vedere di seguito.",
    "LanguageBulkInsertUsers_SuccessTitle": "Controllare le modifiche e confermare.",
    "LanguageBulkInsertUsers_InvalidfileformatError": "Errore: Formato file non valido, utilizzare il nostro modello CSV.",
    "LanguageBulkInsertUsers_MaxfilesizeError": "Errore: Dimensione massima del file superata. È consentito un massimo di 10 MB.",
    "NAME": "LanguageBulkInsertUsers"
}